module.exports = __webpack_public_path__ + "img/30.3c0a269a.jpg";